import gql from "graphql-tag";

const queryGetAllPosition = gql`
  query($status: String, $query: String, $limit: Int, $page: Int) {
    getAllPosition(
      status: $status
      query: $query
      paging: { limit: $limit, page: $page }
    ) {
      id
      name
      updatedAt
      createdAt
      status
    }
  }
`;

const queryGetPosition = gql`
  query($id: ID!) {
    getPosition(id: $id) {
      id
      name
      updatedAt
      createdAt
      status
      author {
        id
        fullname
      }
    }
  }
`;

export default { queryGetAllPosition, queryGetPosition };
